import { NgModule } from '@angular/core';
import { CdkScrollableModule } from '@angular/cdk/scrolling';
import { CheckpointOverviewPageComponent } from './checkpoint-overview-page/checkpoint-overview-page.component';
import { CheckpointDetailPageComponent } from './checkpoint-detail-page/checkpoint-detail-page.component';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from '@components/components.module';
import { UserDetailPageComponent } from './user-detail-page/user-detail-page.component';
import {
  CheckpointGroupOverviewPageComponent,
} from './checkpoint-group-overview-page/checkpoint-group-overview-page.component';
import {
  CheckpointGroupDetailPageComponent,
} from './checkpoint-group-detail-page/checkpoint-group-detail-page.component';
import { TenantDetailPageComponent } from '@pages/tenant-detail-page/tenant-detail-page.component';
import { BuildingOverviewPageComponent } from './building-overview-page/building-overview-page.component';
import { BuildingDetailPageComponent } from './building-detail-page/building-detail-page.component';
import { EmergencyContactsTabComponent } from './building-detail-page/emergency-contacts-tab/emergency-contacts-tab.component';
import { BuildingContactsComponent } from './building-detail-page/building-contacts/building-contacts.component';
import { HouseCareContactsTabComponent } from './building-detail-page/house-care-contacts-tab/house-care-contacts-tab.component';
import { BuildingEnergyPassComponent } from './building-detail-page/building-energy-pass/building-energy-pass.component';
import { BuildingHoraPassComponent } from './building-detail-page/building-hora-pass/building-hora-pass.component';
import { LoginPageComponent } from './login-page/login-page.component';
import { ForcePasswordChangePageComponent } from './force-password-change-page/force-password-change-page.component';
import { TgaTypeOverviewPageComponent } from '@pages/tga-type-overview-page/tga-type-overview-page.component';
import { TgaTypeDetailPageComponent } from '@pages/tga-type-detail-page/tga-type-detail-page.component';
import { TgaTypeFormComponent } from '@pages/tga-type-detail-page/tga-type-form/tga-type-form.component';
import { TgaTypeCollectionsComponent } from '@pages/tga-type-detail-page/tga-type-collections/tga-type-collections.component';
import { TgaTypeProtocolTypesComponent } from '@pages/tga-type-detail-page/tga-type-protocol-types/tga-type-protocol-types.component';
import {
  TgaTypeMaintenanceTimerConfigsComponent
} from '@pages/tga-type-detail-page/tga-type-maintenance-timer-configs/tga-type-maintenance-timer-configs.component';
import {
  TgaTypeLinkedCheckpointsComponent,
} from '@pages/tga-type-detail-page/tga-type-linked-checkpoints/tga-type-linked-checkpoints.component';
import {
  InternalTgaOverviewPageComponent,
} from '@pages/internal-tga-overview-page/internal-tga-overview-page.component';
import {
  BuildingEquipmentDetailPageComponent,
} from './building-equipment-detail-page/building-equipment-detail-page.component';
import {
  BuildingEquipmentFieldsTabComponent,
} from './building-equipment-detail-page/building-equipment-fields-tab/building-equipment-fields-tab.component';
import {
  BuildingEquipmentFoldersTabComponent,
} from './building-equipment-detail-page/building-equipment-folders-tab/building-equipment-folders-tab.component';
import {
  BuildingEquipmentProtocolsTabComponent,
} from './building-equipment-detail-page/building-equipment-protocols-tab/building-equipment-protocols-tab.component';
import {
  BuildingEquipmentRepairTasksTabComponent,
} from './building-equipment-detail-page/building-equipment-repair-tasks-tab/building-equipment-repair-tasks-tab.component';
import { InspectionOverviewPageComponent } from './inspection-overview-page/inspection-overview-page.component';
import { LogoutPageComponent } from './logout-page/logout-page.component';
import { DebugPageComponent } from './debug-page/debug-page.component';
import { SharedModule } from '@shared/shared.module';
import { InspectionDetailPageV2Component } from './inspection-detail-page-v2/inspection-detail-page-v2.component';
import { DetailFormComponent } from './inspection-detail-page-v2/detail-form/detail-form.component';
import {
  InspectionEntriesComponent,
} from './inspection-detail-page-v2/inspection-entries/inspection-entries.component';
import {
  InspectionEntryListItemComponent,
} from './inspection-detail-page-v2/inspection-entries/inspection-entry-group-list/inspection-entry-list-item/inspection-entry-list-item.component';
import {
  InspectionEntryFormComponent,
} from './inspection-detail-page-v2/inspection-entries/inspection-entry-form/inspection-entry-form.component';
import {
  InspectionEntryGroupListComponent,
} from './inspection-detail-page-v2/inspection-entries/inspection-entry-group-list/inspection-entry-group-list.component';
import { InspectionPdfsComponent } from './inspection-detail-page-v2/inspection-pdfs/inspection-pdfs.component';
import {
  InspectionPdfEntryComponent,
} from './inspection-detail-page-v2/inspection-pdfs/inspection-pdf-entry/inspection-pdf-entry.component';
import { TagOverviewPageComponent } from './tag-overview-page/tag-overview-page.component';
import { ConfiguredActionsPageComponent } from './configured-actions-page/configured-actions-page.component';
import { TagDetailPageComponent } from './tag-detail-page/tag-detail-page.component';
import { SettingsPageComponent } from './settings-page/settings-page.component';
import { CustomFieldsSettingsPageComponent } from './custom-fields-settings-page/custom-fields-settings-page.component';
import {
  CustomFieldCollectionSplitViewComponent,
} from '@pages/custom-fields-settings-page/custom-field-collection-split-view/custom-field-collection-split-view.component';
import {
  CustomFieldSplitViewComponent,
} from './custom-fields-settings-page/custom-field-split-view/custom-field-split-view.component';
import {
  CustomFieldFormComponent,
} from './custom-fields-settings-page/custom-field-split-view/custom-field-form/custom-field-form.component';
import {
  CustomFieldDialogComponent,
} from './custom-fields-settings-page/custom-field-split-view/custom-field-dialog/custom-field-dialog.component';
import {
  CustomFieldCollectionDialogComponent,
} from './custom-fields-settings-page/custom-field-collection-split-view/custom-field-collection-dialog/custom-field-collection-dialog.component';
import {
  CustomFieldCollectionFormComponent,
} from './custom-fields-settings-page/custom-field-collection-split-view/custom-field-collection-form/custom-field-collection-form.component';
import { HauFormsModule } from '@sonofabit/ng-core';
import { MapOverviewComponent } from '@pages/map-overview/map-overview.component';
import { PortfolioOverviewPageComponent } from '@pages/portfolio-overview-page/portfolio-overview-page.component';
import { MapOverviewPopupPanelComponent } from './map-overview-popup-panel/map-overview-popup-panel.component';
import { RouterModule } from '@angular/router';
import {
  BuildingRepairTaskOverviewPageComponent,
} from './building-repair-task-overview-page/building-repair-task-overview-page.component';
import {
  BuildingEquipmentsCockpitComponent,
} from './inspection-detail-page-v2/building-equipments-cockpit/building-equipments-cockpit.component';
import {
  CockpitEntryDetailViewComponent,
} from './inspection-detail-page-v2/building-equipments-cockpit/cockpit-entry-detail-view/cockpit-entry-detail-view.component';
import {
  BuildingEquipmentDetailFormComponent,
} from './building-equipment-detail-page/building-equipment-detail-form/building-equipment-detail-form.component';
import { ArchivePageComponent } from './archive-page/archive-page.component';
import { TagListComponent } from '@pages/tag-list/tag-list.component';
import { MetaDataComponent } from './inspection-detail-page-v2/meta-data/meta-data.component';
import { InspectionNotesComponent } from './inspection-detail-page-v2/inspection-notes/inspection-notes.component';
import { ArchiveTabComponent } from './inspection-detail-page-v2/archive-tab/archive-tab.component';
import {
  MaintenanceTimerOverviewComponent,
} from './building-equipment-detail-page/maintenance-timer-overview/maintenance-timer-overview.component';
import {
  MaintenanceTimerComponent,
} from './building-equipment-detail-page/maintenance-timer/maintenance-timer.component';
import {
  InternalMaintenanceTimerOverviewPageComponent,
} from '@pages/internal-maintenance-timer-overview-page/internal-maintenance-timer-overview-page.component';
import { UserDashboardPageComponent } from './user-dashboard-page/user-dashboard-page.component';
import {
  UserDashboardInspectionOverviewComponent,
} from './user-dashboard-page/user-dashboard-inspection-overview/user-dashboard-inspection-overview.component';
import {
  UserDashboardBuildingOverviewComponent,
} from './user-dashboard-page/user-dashboard-building-overview/user-dashboard-building-overview.component';
import {
  UserDashboardRepairTaskOverviewComponent,
} from './user-dashboard-page/user-dashboard-repair-task-overview/user-dashboard-repair-task-overview.component';
import { TenantDashboardPageComponent } from './tenant-dashboard-page/tenant-dashboard-page.component';
import {
  TenantDashboardInspectionOverviewComponent,
} from '@pages/tenant-dashboard-page/tenant-dashboard-inspection-overview/tenant-dashboard-inspection-overview.component';
import {
  TenantDashboardBuildingOverviewComponent,
} from '@pages/tenant-dashboard-page/tenant-dashboard-building-overview/tenant-dashboard-building-overview.component';
import {
  TenantDashboardRepairTaskOverviewComponent,
} from '@pages/tenant-dashboard-page/tenant-dashboard-repair-task-overview/tenant-dashboard-repair-task-overview.component';
import { EmployeeStatisticsPageComponent } from '@pages/employee-statistics-page/employee-statistics-page.component';
import { TenantStatisticsPageComponent, } from '@pages/tenant-statistics-page/tenant-statistics-page.component';
import {
  TenantStatisticsChartsComponent,
} from '@pages/tenant-statistics-page/tenant-statistics-charts/tenant-statistics-charts.component';
import {
  InspectionChartComponent,
} from '@pages/tenant-statistics-page/tenant-statistics-charts/inspection-chart/inspection-chart.component';
import {
  RepairTaskChartComponent,
} from '@pages/tenant-statistics-page/tenant-statistics-charts/repair-task-chart/repair-task-chart.component';
import { SharePdfPageComponent } from './share-pdf-page/share-pdf-page.component';
import { ShareProtocolPdfPageComponent } from './share-protocol-pdf-page/share-protocol-pdf-page.component';
import { TemplateOverviewPageComponent } from '@pages/template-overview-page/template-overview-page.component';
import { TemplateDetailPageComponent } from './template-detail-page/template-detail-page.component';
import { NotificationOverviewPageComponent } from './notification-overview-page/notification-overview-page.component';
import { NotificationsModule } from '@/notifications/notifications.module';
import {
  ExternalBuildingOverviewPageComponent
} from '@pages/external-building-overview-page/external-building-overview-page.component';
import {
  ExternalInspectionOverviewPageComponent
} from '@pages/external-inspection-overview-page/external-inspection-overview-page.component';
import {
  ExternalMaintenanceTimerOverviewPageComponent
} from '@pages/external-maintenance-timer-overview-page/external-maintenance-timer-overview-page.component';
import { AdminUserOverviewPageComponent } from '@pages/admin-user-overview-page/admin-user-overview-page.component';
import { EmailOverviewPageComponent } from './email-overview-page/email-overview-page.component';
import { EmailDetailPageComponent } from './email-detail-page/email-detail-page.component';
import { CypressIdDirective } from '@shared/directives/cypress-id.directive';
import { LandingPageComponent } from '@pages/landing-page/landing-page.component';
import {
  MaintenanceTimerDashboardPageComponent,
} from './maintenance-timer-dashboard-page/maintenance-timer-dashboard-page.component';
import {
  MaintenanceTimerDashboardFilterComponent,
} from './maintenance-timer-dashboard-page/maintenance-timer-dashboard-filter/maintenance-timer-dashboard-filter.component';
import {
  MaintenanceTimerDashboardListComponent,
} from './maintenance-timer-dashboard-page/maintenance-timer-dashboard-list/maintenance-timer-dashboard-list.component';
import {
  MaintenanceTimerStatisticsPageComponent,
} from './maintenance-timer-statistics-page/maintenance-timer-statistics-page.component';
import {
  InspectionDashboardPageComponent,
} from './inspection-dashboard-page/inspection-dashboard-page.component';
import {
  InspectionDashboardFilterComponent,
} from './inspection-dashboard-page/inspection-dashboard-filter/inspection-dashboard-filter.component';
import {
  InspectionDashboardListComponent,
} from './inspection-dashboard-page/inspection-dashboard-list/inspection-dashboard-list.component';
import {
  InspectionEntryStatisticPageComponent,
} from './inspection-entry-statistic-page/inspection-entry-statistic-page.component';
import {
  InspectionEntryStatisticDialogComponent,
} from './inspection-entry-statistic-page/inspection-entry-statistic-dialog/inspection-entry-statistic-dialog.component';
import { DefectReportPageComponent } from './defect-report-page/defect-report-page.component';
import {
  MaintenanceTimerCalendarPageComponent,
} from './maintenance-timer-calendar-page/maintenance-timer-calendar-page.component';
import {
  MaintenanceTimerCalendarCellComponent,
} from './maintenance-timer-calendar-page/maintenance-timer-calendar-cell/maintenance-timer-calendar-cell.component';
import {
  MaintenanceTimerDialogComponent,
} from './maintenance-timer-dashboard-page/maintenance-timer-dialog/maintenance-timer-dialog.component';
import { BuildingScanDetailPageComponent } from './building-scan-detail-page/building-scan-detail-page.component';
import {
  BuildingScanPoiNavigatorComponent,
} from './building-scan-detail-page/building-scan-poi-navigator/building-scan-poi-navigator.component';
import {
  BuildingScanPoiListComponent
} from './building-scan-detail-page/building-scan-poi-navigator/building-scan-poi-list/building-scan-poi-list.component';
import {
  BuildingScanEquipmentTreeViewComponent
} from './building-scan-detail-page/building-scan-poi-navigator/building-scan-equipment-tree-view/building-scan-equipment-tree-view.component';
import {
  BuildingScanEquipmentTreeViewEntryComponent
} from './building-scan-detail-page/building-scan-poi-navigator/building-scan-equipment-tree-view/building-scan-equipment-tree-view-entry/building-scan-equipment-tree-view-entry.component';
import { ShareLinkPageComponent } from './share-link-page/share-link-page.component';
import {
  BuildingScanShareLinkPageComponent
} from './share-link-page/building-scan-share-link-page/building-scan-share-link-page.component';
import { ScanViewerComponent } from './building-scan-detail-page/scan-viewer/scan-viewer.component';
import {
  BuildingScanSplitViewComponent
} from './building-scan-detail-page/building-scan-split-view/building-scan-split-view.component';
import {
  BuildingScanPoiListItemComponent
} from './building-scan-detail-page/building-scan-poi-navigator/building-scan-poi-list/building-scan-poi-list-item/building-scan-poi-list-item.component';
import {
  PoiAttachmentDialogComponent
} from './building-scan-detail-page/building-scan-poi-navigator/building-scan-poi-list/building-scan-poi-list-item/poi-attachment-dialog/poi-attachment-dialog.component';
import {
  BuildingScanEquipmentTreeBuildingEquipmentPopoverComponent
} from './building-scan-detail-page/building-scan-poi-navigator/building-scan-equipment-tree-view/building-scan-equipment-tree-building-equipment-popover/building-scan-equipment-tree-building-equipment-popover.component';
import {
  BuildingScanEquipmentTreeMaintenanceTimerPopoverComponent
} from './building-scan-detail-page/building-scan-poi-navigator/building-scan-equipment-tree-view/building-scan-equipment-tree-maintenance-timer-popover/building-scan-equipment-tree-maintenance-timer-popover.component';
import {
  ExternalTgaOverviewPageComponent
} from '@pages/external-tga-overview-page/external-tga-overview-page.component';
import {
  ExternalTenantOverviewPageComponent
} from '@pages/external-tenant-overview-page/external-tenant-overview-page.component';
import { TenantUserOverviewPageComponent } from '@pages/tenant-user-overview-page/tenant-user-overview-page.component';
import {
  InternalTenantOverviewPageComponent
} from '@pages/internal-tenant-overview-page/internal-tenant-overview-page.component';
import { CorporateGroupOverviewPageComponent } from '@pages/corporate-group-overview-page/corporate-group-overview-page.component';
import { CorporateGroupDetailPageComponent } from '@pages/corporate-group-detail-page/corporate-group-detail-page.component';
import { TenantRoleOverviewPageComponent } from '@pages/tenant-role-overview-page/tenant-role-overview-page.component';
import { TenantRoleDetailPageComponent } from './tenant-role-detail-page/tenant-role-detail-page.component';
import { TeamOverviewPageComponent } from '@pages/team-overview-page/team-overview-page.component';
import { TeamDetailPageComponent } from './team-detail-page/team-detail-page.component';
import { RegionOverviewPageComponent } from '@pages/region-overview-page/region-overview-page.component';
import { RegionDetailPageComponent } from '@pages/region-detail-page/region-detail-page.component';
import {
  BuildingWorkItemOverviewPageComponent
} from '@pages/building-work-item-overview-page/building-work-item-overview-page.component';
import {
  AttachmentFolderOverviewPageComponent
} from '@pages/attachment-folder-overview-page/attachment-folder-overview-page.component';
import {
  AttachmentFolderDetailPageComponent
} from '@pages/attachment-folder-detail-page/attachment-folder-detail-page.component';
import {
  ContractorTenantOverviewPageComponent
} from '@pages/contractor-tenant-overview-page/contractor-tenant-overview-page.component';
import { TenantTypePipe } from '@shared/pipes/tenant-type.pipe';
import {
  ContractorBuildingOverviewPageComponent
} from '@pages/contractor-building-overview-page/contractor-building-overview-page.component';
import {
  ContractorRepairTaskOverviewPageComponent,
} from '@pages/contractor-repair-task-overview-page/contractor-repair-task-overview-page.component';
import {
  ContractorRepairTaskDetailDialogComponent,
} from '@pages/contractor-repair-task-overview-page/contractor-repair-task-detail-dialog/contractor-repair-task-detail-dialog.component';
import {
  ContractorScopeConfigurationPageComponent
} from '@pages/contractor-scope-configuration-page/contractor-scope-configuration-page.component';
import {
  ContractorAttachmentFolderConfigurationPageComponent
} from '@pages/contractor-attachment-folder-configuration-page/contractor-attachment-folder-configuration-page.component';
import {
  BuildingInspectionOverviewComponent
} from '@pages/building-detail-page/building-inspection-overview/building-inspection-overview.component';
import {
  BuildingTgaOverviewComponent
} from '@pages/building-detail-page/building-tga-overview/building-tga-overview.component';
import { TeamDashboardPageComponent } from '@pages/team-dashboard-page/team-dashboard-page.component';
import {
  TeamDashboardInfoComponent
} from '@pages/team-dashboard-page/team-dashboard-info/team-dashboard-info.component';
import { TeamDashboardMapComponent } from '@pages/team-dashboard-page/team-dashboard-map/team-dashboard-map.component';
import { RegionDashboardPageComponent } from '@pages/region-dashboard-page/region-dashboard-page.component';
import {
  RegionDashboardInfoComponent
} from '@pages/region-dashboard-page/region-dashboard-info/region-dashboard-info.component';
import {
  RegionDashboardMapComponent
} from '@pages/region-dashboard-page/region-dashboard-map/region-dashboard-map.component';
import {
  RegionDashboardTeamcardsComponent
} from '@pages/region-dashboard-page/region-dashboard-teamcards/region-dashboard-teamcards.component';
import {
  ContractorBuildingAssignmentPageComponent
} from '@pages/contractor-building-assignment-page/contractor-building-assignment-page.component';
import {
  CheckpointDetailFormComponent
} from '@pages/checkpoint-detail-page/checkpoint-detail-form/checkpoint-detail-form.component';
import {
  AssessmentDetailFormComponent
} from '@pages/checkpoint-detail-page/assessment-detail-form/assessment-detail-form.component';
import { SensorBlockDetailPageComponent } from '@pages/sensor-block-detail-page/sensor-block-detail-page.component';
import { SensorBlockChartPageComponent } from '@pages/sensor-block-chart-page/sensor-block-chart-page.component';
import { PlotlyComponent } from 'angular-plotly.js';
import { LabelOverviewPageComponent } from '@pages/label-overview-page/label-overview-page.component';
import { LabelDetailPageComponent } from '@pages/label-detail-page/label-detail-page.component';
import { NbBadgeModule } from '@nebular/theme';
import {
  TenantContractorExternalConfigPageComponent
} from '@pages/tenant-detail-page/tenant-contractor-external-config-page/tenant-contractor-external-config-page.component';
import {
  BuildingFlatOverviewComponent
} from '@pages/building-detail-page/building-flat-overview/building-flat-overview.component';
import { FlatDetailPageComponent } from '@pages/flat-detail-page/flat-detail-page.component';
import {
  ResidentDialogComponent,
} from '@pages/flat-detail-page/dialogs/resident-dialog.component';
import {
  CheckoutResidentDialogComponent,
} from '@pages/flat-detail-page/dialogs/checkout-resident-dialog.component';
import {
  TenantGuidelinesConfigComponent
} from '@pages/tenant-detail-page/tenant-guidelines-config/tenant-guidelines-config.component';
import { QrCodeGeneratePageComponent } from '@pages/qr-code-generate-page/qr-code-generate-page.component';
import {
  QrCodeBuildingOverviewPageComponent
} from '@pages/qr-code-building-overview-page/qr-code-building-overview-page.component';
import { QrCodePinLoginComponent } from '@pages/qr-code-pin-login/qr-code-pin-login.component';
import { QrCodeTgaOverviewPageComponent } from '@pages/qr-code-tga-overview-page/qr-code-tga-overview-page.component';
import {
  QrCodeMaintenanceTimerPageComponent
} from '@pages/qr-code-maintenance-timer-page/qr-code-maintenance-timer-page.component';
import {
  QrCodeMaintenanceTimerFinishPageComponent
} from '@pages/qr-code-maintenance-timer-finish-page/qr-code-maintenance-timer-finish-page.component';
import { QrCodeTgaDetailPageComponent } from '@pages/qr-code-tga-detail-page/qr-code-tga-detail-page.component';
import { QrCodeRepairTaskPageComponent } from '@pages/qr-code-repair-task-page/qr-code-repair-task-page.component';
import {
  MaintenanceTimerHistoryOverviewPageComponent
} from '@pages/maintenance-timer-history-overview-page/maintenance-timer-history-overview-page.component';
import {
  MaintenanceTimerHistoryDetailPageComponent
} from '@pages/maintenance-timer-history-detail-page/maintenance-timer-history-detail-page.component';
import { TgaStatisticPageComponent } from '@pages/tga-statistic-page/tga-statistic-page.component';
import {
  TgaStatisticDialogComponent
} from '@pages/tga-statistic-page/tga-statistic-dialog/tga-statistic-dialog.component';
import {
  BuildingPointCloudScanPageComponent
} from '@pages/building-point-cloud-scan-page/building-point-cloud-scan-page.component';
import {
  BuildingPointCloudScanShareLinkPageComponent
} from '@pages/share-link-page/building-point-cloud-scan-share-link-page/building-point-cloud-scan-share-link-page.component';
import {
  BuildingBillingAddressesComponent
} from '@pages/building-detail-page/building-billing-addresses/building-billing-addresses.component';
import {
  BuildingProfiNeoSyncPageComponent
} from '@pages/building-detail-page/building-profi-neo-sync-page/building-profi-neo-sync-page.component';
import {
  BuildingProfiNeoSanierungSyncPageComponent
} from '@pages/building-detail-page/building-profi-neo-sanierung-sync-page/building-profi-neo-sanierung-sync-page.component';
import {
  BuildingSubtenantOverviewComponent
} from '@pages/building-detail-page/building-subtenant-overview/building-subtenant-overview.component';
import {
  SubtenantAssignDialogComponent
} from '@pages/building-detail-page/building-subtenant-overview/subtenant-assign-dialog/subtenant-assign-dialog.component';
import { BuildingApplicationOverviewComponent } from '@pages/building-application/building-application-overview/building-application-overview.component';
import {
  BuildingApplicationDetailComponent
} from '@pages/building-application/building-application-detail/building-application-detail.component';
import {
  BuildingApplicationAdminOverviewComponent
} from '@pages/building-application/building-application-admin-overview/building-application-admin-overview.component';
import {
  BuildingApplicationAdminDetailComponent
} from '@pages/building-application/building-application-admin-detail/building-application-admin-detail.component';
import {
  BuildingAmenityFormComponent
} from '@pages/building-detail-page/building-form-page/building-amenity-form/building-amenity-form.component';
import {
  BuildingAccessFormComponent
} from '@pages/building-detail-page/building-form-page/building-access-form/building-access-form.component';
import {
  BuildingAllocationFormComponent
} from '@pages/building-detail-page/building-form-page/building-allocation-form/building-allocation-form.component';
import {
  BuildingBaseDataFormComponent
} from '@pages/building-detail-page/building-form-page/building-base-data-form/building-base-data-form.component';
import {
  BuildingInternalDataFormComponent
} from '@pages/building-detail-page/building-form-page/building-internal-data-form/building-internal-data-form.component';
import { GenericModule } from '@shared/generic/generic.module';
import {
  ProtocolTypeOverviewPageComponent,
} from '@pages/protocol-type-overview-page/protocol-type-overview-page.component';
import {
  ProtocolTypeDetailPageComponent,
} from '@pages/protocol-type-detail-page/protocol-type-detail-page.component';
import {
  ProtocolTypeFormComponent,
} from '@pages/protocol-type-detail-page/protocol-type-form/protocol-type-form.component';
import {
  ProtocolTypeSettingsComponent,
} from '@pages/protocol-type-detail-page/protocol-type-settings/protocol-type-settings.component';
import {
  ProtocolTypeCollectionsComponent,
} from '@pages/protocol-type-detail-page/protocol-type-collections/protocol-type-collections.component';
import {
  ProtocolOverviewPageComponent,
} from '@pages/protocol-overview-page/protocol-overview-page.component';
import {
  ProtocolCreationPageComponent,
} from '@pages/protocol-creation-page/protocol-creation-page.component';
import {
  ProtocolDetailPageComponent,
} from '@pages/protocol-detail-page/protocol-detail-page.component';
import {
  BuildingProtocolOverviewComponent,
} from '@pages/building-detail-page/building-protocol-overview/building-protocol-overview.component';
import {
  BuildingRepairTaskOverviewComponent,
} from '@pages/building-detail-page/building-repair-task-overview/building-repair-task-overview.component';


import { QrExternalBuildingsPageComponent } from '@pages/qr-external-buildings-page/qr-external-buildings-page.component';
import { QrCodeBuildingHeaderComponent } from '@pages/qr-code-building-header/qr-code-building-header.component';
import {
  QrRepairTaskMailDialogComponent,
} from '@pages/qr-code-tga-detail-page/qr-repair-task-mail-dialog/qr-repair-task-mail-dialog.component';

import { UserQrPinComponent } from '@pages/user-detail-page/user-qr-pin/user-qr-pin.component';
@NgModule({
  declarations: [
    LoginPageComponent,
    ForcePasswordChangePageComponent,
    LogoutPageComponent,
    CheckpointOverviewPageComponent,
    CheckpointDetailPageComponent,
    BuildingOverviewPageComponent,
    BuildingDetailPageComponent,
    EmergencyContactsTabComponent,
    HouseCareContactsTabComponent,
    BuildingContactsComponent,
    BuildingEnergyPassComponent,
    BuildingHoraPassComponent,
    AdminUserOverviewPageComponent,
    UserDetailPageComponent,
    CheckpointGroupOverviewPageComponent,
    CheckpointGroupDetailPageComponent,
    TenantDetailPageComponent,
    TgaTypeOverviewPageComponent,
    TgaTypeDetailPageComponent,
    TgaTypeFormComponent,
    TgaTypeCollectionsComponent,
    TgaTypeProtocolTypesComponent,
    TgaTypeMaintenanceTimerConfigsComponent,
    TgaTypeLinkedCheckpointsComponent,
    InternalTgaOverviewPageComponent,
    BuildingEquipmentDetailPageComponent,
    BuildingEquipmentFieldsTabComponent,
    BuildingEquipmentFoldersTabComponent,
    BuildingEquipmentProtocolsTabComponent,
    BuildingEquipmentRepairTasksTabComponent,
    InspectionOverviewPageComponent,
    DebugPageComponent,
    InspectionDetailPageV2Component,
    DetailFormComponent,
    InspectionEntriesComponent,
    InspectionEntryListItemComponent,
    InspectionEntryFormComponent,
    InspectionEntryGroupListComponent,
    SettingsPageComponent,
    TagOverviewPageComponent,
    ConfiguredActionsPageComponent,
    TagDetailPageComponent,
    InspectionPdfsComponent,
    InspectionPdfEntryComponent,
    CustomFieldsSettingsPageComponent,
    CustomFieldCollectionSplitViewComponent,
    CustomFieldSplitViewComponent,
    CustomFieldFormComponent,
    CustomFieldDialogComponent,
    CustomFieldCollectionDialogComponent,
    CustomFieldCollectionFormComponent,
    ArchivePageComponent,
    TagListComponent,
    BuildingEquipmentsCockpitComponent,
    CockpitEntryDetailViewComponent,
    BuildingEquipmentDetailFormComponent,
    BuildingRepairTaskOverviewPageComponent,
    MetaDataComponent,
    InspectionNotesComponent,
    ArchiveTabComponent,
    MapOverviewComponent,
    MapOverviewPopupPanelComponent,
    PortfolioOverviewPageComponent,
    MaintenanceTimerOverviewComponent,
    MaintenanceTimerComponent,
    UserDashboardPageComponent,
    UserDashboardInspectionOverviewComponent,
    UserDashboardBuildingOverviewComponent,
    UserDashboardRepairTaskOverviewComponent,
    TenantDashboardPageComponent,
    TenantDashboardInspectionOverviewComponent,
    TenantDashboardBuildingOverviewComponent,
    TenantDashboardRepairTaskOverviewComponent,
    InternalMaintenanceTimerOverviewPageComponent,
    EmployeeStatisticsPageComponent,
    TenantStatisticsPageComponent,
    TenantUserOverviewPageComponent,
    TenantStatisticsChartsComponent,
    InspectionChartComponent,
    RepairTaskChartComponent,
    SharePdfPageComponent,
    ShareProtocolPdfPageComponent,
    TemplateOverviewPageComponent,
    TemplateDetailPageComponent,
    ExternalBuildingOverviewPageComponent,
    ExternalInspectionOverviewPageComponent,
    ExternalMaintenanceTimerOverviewPageComponent,
    AdminUserOverviewPageComponent,
    EmailOverviewPageComponent,
    EmailDetailPageComponent,
    NotificationOverviewPageComponent,
    MaintenanceTimerDashboardPageComponent,
    MaintenanceTimerDashboardFilterComponent,
    MaintenanceTimerDashboardListComponent,
    MaintenanceTimerCalendarPageComponent,
    MaintenanceTimerCalendarCellComponent,
    MaintenanceTimerDialogComponent,
    MaintenanceTimerStatisticsPageComponent,
    InspectionDashboardPageComponent,
    InspectionDashboardFilterComponent,
    InspectionDashboardListComponent,
    InspectionEntryStatisticPageComponent,
    InspectionEntryStatisticDialogComponent,
    DefectReportPageComponent,
    QrExternalBuildingsPageComponent,
    QrCodeBuildingHeaderComponent,
    QrRepairTaskMailDialogComponent,
    UserQrPinComponent,
    LandingPageComponent,
    BuildingScanDetailPageComponent,
    BuildingScanPoiNavigatorComponent,
    BuildingScanPoiListComponent,
    BuildingScanEquipmentTreeViewComponent,
    BuildingScanEquipmentTreeViewEntryComponent,
    BuildingScanPoiListItemComponent,
    PoiAttachmentDialogComponent,
    BuildingScanEquipmentTreeBuildingEquipmentPopoverComponent,
    BuildingScanEquipmentTreeMaintenanceTimerPopoverComponent,
    ShareLinkPageComponent,
    BuildingScanShareLinkPageComponent,
    ScanViewerComponent,
    BuildingScanSplitViewComponent,
    ExternalTenantOverviewPageComponent,
    InternalTenantOverviewPageComponent,
    CorporateGroupOverviewPageComponent,
    CorporateGroupDetailPageComponent,
    ExternalTgaOverviewPageComponent,
    TenantRoleOverviewPageComponent,
    TenantRoleDetailPageComponent,
    TeamOverviewPageComponent,
    TeamDetailPageComponent,
    RegionOverviewPageComponent,
    RegionDetailPageComponent,
    BuildingWorkItemOverviewPageComponent,
    AttachmentFolderOverviewPageComponent,
    AttachmentFolderDetailPageComponent,
    ContractorTenantOverviewPageComponent,
    ContractorBuildingOverviewPageComponent,
    ContractorRepairTaskOverviewPageComponent,
    ContractorRepairTaskDetailDialogComponent,
    ContractorScopeConfigurationPageComponent,
    ContractorAttachmentFolderConfigurationPageComponent,
    BuildingInspectionOverviewComponent,
    BuildingTgaOverviewComponent,
    TeamDashboardPageComponent,
    TeamDashboardInfoComponent,
    TeamDashboardMapComponent,
    RegionDashboardPageComponent,
    RegionDashboardInfoComponent,
    RegionDashboardMapComponent,
    RegionDashboardTeamcardsComponent,
    ContractorBuildingAssignmentPageComponent,
    CheckpointDetailFormComponent,
    AssessmentDetailFormComponent,
    SensorBlockDetailPageComponent,
    SensorBlockChartPageComponent,
    LabelOverviewPageComponent,
    LabelDetailPageComponent,
    TenantContractorExternalConfigPageComponent,
    BuildingFlatOverviewComponent,
    FlatDetailPageComponent,
    ResidentDialogComponent,
    CheckoutResidentDialogComponent,
    TenantGuidelinesConfigComponent,
    QrCodeGeneratePageComponent,
    QrCodeBuildingOverviewPageComponent,
    QrCodePinLoginComponent,
    QrCodeTgaOverviewPageComponent,
    QrCodeMaintenanceTimerPageComponent,
    QrCodeMaintenanceTimerFinishPageComponent,
    QrCodeTgaDetailPageComponent,
    QrCodeRepairTaskPageComponent,
    MaintenanceTimerHistoryOverviewPageComponent,
    MaintenanceTimerHistoryDetailPageComponent,
    TgaStatisticPageComponent,
    TgaStatisticDialogComponent,
    BuildingPointCloudScanPageComponent,
    BuildingPointCloudScanShareLinkPageComponent,
    BuildingBillingAddressesComponent,
    BuildingApplicationOverviewComponent,
    BuildingApplicationDetailComponent,
    BuildingApplicationAdminOverviewComponent,
    BuildingApplicationAdminDetailComponent,
    BuildingProfiNeoSyncPageComponent,
    BuildingProfiNeoSanierungSyncPageComponent,
    BuildingAmenityFormComponent,
    BuildingAccessFormComponent,
    BuildingAllocationFormComponent,
    BuildingBaseDataFormComponent,
    BuildingInternalDataFormComponent,
    BuildingSubtenantOverviewComponent,
    ProtocolTypeOverviewPageComponent,
    ProtocolTypeDetailPageComponent,
    ProtocolTypeFormComponent,
    ProtocolTypeSettingsComponent,
    ProtocolTypeCollectionsComponent,
    ProtocolOverviewPageComponent,
    ProtocolCreationPageComponent,
    ProtocolDetailPageComponent,
    BuildingProtocolOverviewComponent,
    BuildingRepairTaskOverviewComponent,
    SubtenantAssignDialogComponent,
  ],
  imports: [
    CdkScrollableModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    ComponentsModule,
    SharedModule,
    HauFormsModule,
    RouterModule,
    NotificationsModule,
    CypressIdDirective,
    PlotlyComponent,
    NbBadgeModule,
    NgOptimizedImage,
    GenericModule,
  ],
  exports: [
    CustomFieldFormComponent,
    TenantTypePipe,
    MaintenanceTimerComponent,
  ],
  providers: [
    TenantTypePipe,
  ],
})
export class PagesModule {
}
